import React, { useEffect, useState } from "react";
import { CIcon } from '@coreui/icons-react';
import {  cilEnvelopeClosed, cilPhone } from '@coreui/icons';
import { doc, getDoc } from "firebase/firestore";
import db from "../../firebase/firebaseConfig";
import { useNavigate, useParams } from "react-router-dom";
import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase/firebaseConfig"
import { useAuth } from "../../contexts/authContext";
import { useLoading } from "../Loading";
import { format } from "date-fns";

function LostFoundDetails() {
    const navigate = useNavigate();
    const { id } = useParams()
    const [pets, setPets] = useState({});
    const [imageUrls, setImageUrls] = useState("/blue.gif");
    const {setLoading} = useLoading();
    const {currentUser} = useAuth();

    useEffect(() => {
        console.log(id);
        if (!id) {
            navigate("/adopt");
        }
        const fetchPets = async () => {
            const petId = id;
            const petCollection = doc(db, "LostFound", petId);
            const petSnapshot = await getDoc(petCollection);
            if (petSnapshot.exists()) {
                const petList = { id: petId, ...petSnapshot.data() };
                setPets(petList);
                setLoading(false);

                const petCollection = doc(db, "Adopters", petSnapshot.data().adopterId);
                const petSnap = await getDoc(petCollection);
                if(petSnap.exists())
                {
                    if(petSnapshot.data().phoneNumber)
                    {
                        setPets((prevPets) => ({
                            ...prevPets,
                            phoneNumber: petSnap.data().phoneNumber,
                        }));
                    }
                    else if(petSnapshot.data().email)
                    {
                        setPets((prevPets) => ({
                            ...prevPets,
                            email: petSnap.data().email,
                        }));
                    }
                   
                }
            }
            else{
                navigate("/adopt");
            }
        };

        fetchPets();
    }, [id, navigate]);
   

    useEffect(() => {
        const fetchImages = async () => {
            if (!pets.image) return;
            try {
                const imageRef = ref(storage, `LostFound/${pets.image}`);
                const url = await getDownloadURL(imageRef);
                setImageUrls(url);

            } catch (error) {
                console.error(error);
                setImageUrls("/blue.gif");  // Fallback image
            }

        };

        fetchImages();

    }, [pets.image, pets.id]);


    return (
        <div className="petDetailsContainer">
        <div className="detailCard" >
            <div className="row g-0">
                <div className="col-md-6">
                    <img src={imageUrls} className="img-fluid" alt="..." />

                </div>
                <div className="col-md-6">
                    <div className="card-body">
                        <h4 className="cardTitle">{pets.petName}</h4>
                        <p className="card-text">{pets.breed}</p>
                        <div className="petDetailsList">
                            <table>
                                <tbody>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Status:</td>
                                        <td className="detailValue">{pets.status || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Location:</td>
                                        <td className="detailValue">{pets.location || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Colour:</td>
                                        <td className="detailValue">{pets.colour || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Gender:</td>
                                        <td className="detailValue">{pets.gender || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Age:</td>
                                        <td className="detailValue">{pets.age || "Unknown"}</td>
                                    </tr>
                                    <tr className="detail-row">
                                        <td className="detailLabel">Size:</td>
                                        <td className="detailValue">{pets.size || "Unknown"}</td>
                                    </tr>
                                   { pets.createdAt&&<tr className="detail-row">
                                        <td className="detailLabel">Created At:</td>
                                        <td className="detailValue">{(format(pets.createdAt.toDate(), 'M/d/yyyy, h:mm a')) || "Unknown"}</td>
                                    </tr>}
                                </tbody>
                            </table>
                            <div className="shelterInfo">
                                <div className="shelterBtn">
                                    <button style={{pointerEvents: pets.phoneNumber?"auto":"none", background:"none"}}
                                    onClick={() => {
                                        if (currentUser) {
                                            window.location.href = `tel:${pets.phoneNumber}`;
                                        } else {
                                            navigate('/login');
                                        }
                                    }}>
                                        <CIcon icon={cilPhone} size="3xl" style={{ transform: "scaleX(-1)", color: pets.phoneNumber?"#70d2ff":"#bababa" }} />
                                    </button>
                                    <button  style={{ pointerEvents: pets.email ? 'auto' : 'none', background:"none"  }}
                                    onClick={() => {
                                        if (currentUser) {
                                            window.location.href = `mailto:${pets.email}?subject=${encodeURIComponent(
                                                "Urgent: Inquiry About Your Lost/Found Pet"
                                            )}&body=${encodeURIComponent(
                                                "Hello,\n\nI need more information about the pet you have listed. Please provide details at your earliest convenience.\n\nBest regards,\n[Your Name]"
                                            )}`;
                                        } else {
                                            navigate('/login');
                                        }
                                    }}>
                                        <CIcon icon={cilEnvelopeClosed} size="3xl" style={{  color: pets.email ? "#70d2ff": "#bababa" }} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default LostFoundDetails;